import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Retry transient failures (network / edge hiccups) so catalog pages never render empty by accident.
const getWithRetry = async (url, config, attempts = 3) => {
  let lastErr;
  for (let i = 0; i < attempts; i++) {
    try {
      const r = await axios.get(url, config);
      return r.data;
    } catch (e) {
      lastErr = e;
      if (e.response && e.response.status < 500) throw e; // real 4xx — don't retry
      await new Promise((res) => setTimeout(res, 400 * (i + 1)));
    }
  }
  throw lastErr;
};

export const fetchProducts = (params = {}) =>
  getWithRetry(`${API}/products`, { params });

export const fetchProduct = (slug) =>
  getWithRetry(`${API}/products/${slug}`);

export const createOrder = (payload) =>
  axios.post(`${API}/orders`, payload).then((r) => r.data);

export const subscribeNotify = (payload) =>
  axios.post(`${API}/notify`, payload).then((r) => r.data);
